import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { object, number } from 'prop-types'
import { EMPTY_OBJECT } from '../../../utils/constants'
import { useGallery } from '../../../providers/GalleryProvider'
import { buildImageSwiperConfig } from '../../ui/ad-swiper/swiper-config'
import AdSwiper from '../../ui/ad-swiper/AdSwiper'
import SaveButton from '../../ui/button/SaveButton'
import Image from '../../ui/image/Image'
import { getGalleryFormattedUrl } from '../../gallery-details/helpers'
import Insights from '../Insights'

/**
 *  ImageGrid - Container for image results
 *
 * @param {Object} props
 * @param {Object} props.item - Image result object
 * @returns ReactNode
 */
const ImageGrid = ({
  item = EMPTY_OBJECT,
  index: resultIndex,
  insights
}) => {
  const { images, parent_info: parentInfo } = item
  if (item.images.length === 0) {
    return null
  }
  const parentUrlData = parentInfo.url && getGalleryFormattedUrl(parentInfo.url)
  const { openGallery } = useGallery()
  return (<Insights className='gridview__item image-result' {...insights} key={resultIndex + item.parent_info.id}>
    {images.length > 1 ? (
      <AdSwiper isLazy params={buildImageSwiperConfig} isVirtual>
        {images.map((image, index) => (
          <SwiperSlide virtualIndex={index > 0 ? index : false} key={index}>
            <div key={index} className='project-object__image-wrapper'
              onClick={e => openGallery(e, index, resultIndex)}
              data-save={index === 0}>
              {/* eslint-disable max-len */}
              <Image alt={image.alt} src={image.sizes.medium} data-object-fit='cover' className='swiper-lazy' loading='lazy' />
              <div className='project-object__save-buttons'>
                <SaveButton key={index} url={`${parentUrlData.url}${image.slug}`} image={image.sizes.medium} title={image.caption || ''} gridView insights={insights} id={image.slug} rest={{ 'data-slug': image.slug }} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </AdSwiper>
    ) : (
      <div className='project-object__image-wrapper'
        onClick={e => openGallery(e, 0, resultIndex)}
      >
        <Image src={images.length === 1 ? images[0].sizes.medium : ''} data-object-fit='cover' />
        <SaveButton url={`${parentUrlData.url}${images[0].slug}`} image={images[0].sizes.medium} title={images[0].caption || ''} gridView insights={insights} />
      </div>
    )}
    {/* <div className='project-object__save-buttons'>
        {images.length > 1 && (images.map((image, index) => (
          <SaveButton key={index} url={`${parentUrlData.url}${image.slug}`} image={image.sizes.medium} title={image.caption || ''} gridView insights={insights} isInit={index === 0} />
        )))}
      </div> */}
  </Insights>)
}

ImageGrid.propTypes = {
  item: object,
  index: number,
  insights: object
}

export default React.memo(ImageGrid)
